import React from 'react';
import Header from './Header';
import Footer from './Footer';
import BottomNav from './BottomNav';

const Layout = ({ children }) => {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
      <BottomNav />
    </>
  );
};

export default Layout;
